import { MapPin, ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import SUBURBS from "@/data/suburbs";
import { Reveal } from "@/components/landing/Reveal";

export const Suburbs = () => (
  <section data-testid="suburbs-section" className="py-24 sm:py-32 bg-brand-light/40">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <p className="font-bold text-xs tracking-[0.3em] text-brand uppercase mb-4">Chapter 08 — Our stomping ground</p>
        <h2 className="font-bebas text-5xl sm:text-6xl lg:text-7xl text-navy leading-[0.9] max-w-4xl">
          ROCKINGHAM TO JOONDALUP. <span className="text-brand">ALL COVERED.</span>
        </h2>
        <p className="mt-6 max-w-2xl text-navy/60">
          Tap your suburb — same price, same pick-your-time booking, same crew.
        </p>
      </Reveal>
      <Reveal delay={0.1} className="mt-12">
        <div className="flex flex-wrap gap-2.5">
          {SUBURBS.map((s) => (
            <Link
              key={s.slug}
              to={`/leak-detection/${s.slug}`}
              data-testid={`suburb-link-${s.slug}`}
              className="group inline-flex items-center gap-1.5 rounded-full bg-white border border-border px-4 py-2 text-sm font-semibold text-navy/70 hover:border-brand hover:text-brand hover:-translate-y-0.5 transition-[transform,color,border-color] duration-200"
            >
              <MapPin className="w-3.5 h-3.5 text-brand" />
              {s.name}
              <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
            </Link>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
